import { z } from 'zod';

/**
 * Schéma pour la création/édition d'une classe
 * Aligné avec le backend: tous les IDs sont des UUIDs (strings)
 */
export const classSchema = z.object({
  name: z.string().min(2, 'Le nom doit contenir au moins 2 caractères'),
  establishmentId: z.string().uuid("L'établissement doit être un UUID valide"),
  levelExternalId: z.string().uuid('Le niveau doit être un UUID valide'),
  sectionId: z.string().uuid('La section doit être un UUID valide').optional(),
  schoolYearId: z.string().uuid("L'année scolaire doit être un UUID valide"),
  statusId: z.string().uuid('Le statut doit être un UUID valide'),
  maxStudents: z
    .number()
    .min(1, 'Le nombre maximum doit être au moins 1')
    .max(99, 'Le nombre maximum ne peut pas dépasser 99'),
});

export type ClassFormData = z.infer<typeof classSchema>;
